<div class="dialog-header">
    <div class="header-side"></div>
    <div class="dialog-title-text">
      {{dialogTitle()}}
    </div>
    <button mat-icon-button class="close-btn" (click)="onCancel()">
      <mat-icon>close</mat-icon>
    </button>
  </div>
  <mat-dialog-content>  
    <form [formGroup]="oraForm" class="form-grid">        
        <div class="form-grid-row">
            <!-- Start Date -->
            <mat-form-field appearance="outline">
                <mat-label>Date</mat-label>
                <input matInput [matDatepicker]="startDatePicker" formControlName="captureDate" placeholder="MM/dd/yyyy"
                    (keydown)="onKeydown($event)" (blur)="dateformat($event)">
                <mat-datepicker-toggle matSuffix [for]="startDatePicker"></mat-datepicker-toggle>
                <mat-datepicker #startDatePicker></mat-datepicker>
                <mat-error *ngIf="oraForm.get('captureDate')?.hasError('required')">
                    Date is required
                </mat-error>
            </mat-form-field>
        </div>
        <div class="form-grid-row">
            <mat-form-field appearance="outline">
                <mat-label>Revenue Type</mat-label>
                <mat-select formControlName="revenueType" required>
                    @for (type of revenueTypes(); track type.id) {
                        <mat-option [value]="type.id">{{ type.name }}</mat-option>
                    }
                </mat-select>
                <mat-error>Revenue Type is required</mat-error>                
            </mat-form-field>
        </div>
        <div class="form-grid-row">
            <!-- Number of Hauls -->
            <mat-form-field appearance="outline">
                <mat-label>Number of Hauls</mat-label>
                <input matInput type="text" formControlName="numberofHauls" (input)="roundOff($event, 9999, 0, 'numberofHauls')">
                <mat-error>Number of Hauls is required</mat-error>
            </mat-form-field>
        </div>
         <div class="form-grid-row">
            <!-- Total Tons -->
            <mat-form-field appearance="outline">
                <mat-label>Total Tons</mat-label>
                <input matInput type="text" formControlName="totalTons" (input)="roundOff($event, 99999, 4, 'totalTons')">
                <mat-error>Total Tons is required</mat-error>
            </mat-form-field>
        </div>
    </form>
  </mat-dialog-content>
  <mat-dialog-actions align="end">
    <button mat-raised-button color="primary" (click)="onCancel()">Cancel</button>
    @if(canSave){
        <button mat-raised-button color="primary" (click)="onSave()">Save</button>
    }
  </mat-dialog-actions>
  